import style from './cadastros.module.css'
import { use, useEffect, useState } from 'react'
import { BiX } from 'react-icons/bi'
import {addItem, getDocumentoUnico, registrarProfessor } from "../../firebase/CRUD"
import { getItens, getDocCollection,updateItem } from '../../firebase/CRUD'
import { useAuth } from '../../hooks/AuthContext'
import { useToast } from '../../hooks/Toast'
import Input from '../layout/Input/Input'
import Button from '../layout/Button/Button'
import { Selection } from '../layout/Selection/Selection'

export const salvar=({localstore,item,idEscola})=>{
    return addItem(localstore,item,idEscola)
}


export function FormAluno({cadastramento,edit}){
    const {usuario} = useAuth()
    const {mostrarAviso} = useToast()
    const [formData, setFormData] = useState(edit || {
        nome: '',
        genero: '',
        dataNascimento: new Date(),
        turma: '',
        turmaNome: '',
        historico: {},
        presencas: 0,
        faltas: 0,
        faltasSeguidas: 0,
        pontos: 0,
    })
    const [turma,setTurma] = useState("")
    const [turmaNome, setTurmaNome] = useState("")
    const [turmas, setTurmas] = useState([])
    const [historico,setHistorico] = useState({})

    
    const buscar = (key,lista)=>{
        const tam = lista.length
        console.log(lista)
        for(let i = 0; i < tam; i++){
            if(key == lista[i].id){
                return lista[i].nome
            }
        }
    }
    const handleInputChange = (e)=>{
        const {value, name} = e.target
        setFormData({
            ...formData,
            [name]: value
        })
    }
    useEffect(()=>{
        if(usuario.perfil == 'prof'){
            const pegarTurma = (doc)=>{
                setTurma(doc.id)
                setTurmaNome(doc.nome)
            }
            getDocumentoUnico("turmas",usuario.turma,pegarTurma,usuario.idEscola)
        }
           
        if(usuario.perfil == 'adm')
            getDocCollection("turmas",setTurmas,usuario.idEscola)
    },[])

    return(
    <div className={`${style.envelope_box}`}>
        <div className={`${style.cad_box}`}>
            <div className={`${style.cabecalhoForm}`} >
                <BiX size={30} onClick={cadastramento}/>
                <p className={`${style.cabecalhoFormp}`}
                >Preencha o formulário para realizar a matrícula</p>
            </div>
            <form className={`${style.formBody}`}>
                <Input 
                    label={'Nome do aluno'}
                    name={'nome'}
                    value={formData.nome}
                    onChange={handleInputChange}
                    placeholder={'Digite o nome do aluno'}
                    minLength={1}
                    required={true}
                />
                <div className={`${style.radioGoup}`}>
                    <span className={`${style.radioLabel}`}>Gênero:</span>
                    <div className={`${style.radioOptions}`}>
                    <label className={`${style.radioOption}`}>
                        <input 
                        type="radio" 
                        name="genero" 
                        value="M" 
                        onChange={handleInputChange} 
                        checked={formData?.genero === "M"} 
                        required 
                        />
                        Masculino
                    </label>
                    <label className={`${style.radioOption}`}>
                        <input 
                        type="radio" 
                        name="genero" 
                        value="F" 
                        onChange={handleInputChange} 
                        checked={formData?.genero === "F"} 
                        />
                        Feminino
                    </label>
                    </div>
                </div>
                <div>
                    <Input 
                        label={'Nascimento'}
                        value={formData.dataNascimento}
                        onChange={handleInputChange}
                        type='date'
                        name={'dataNascimento'}
                    />
                </div>
                <div>
                    {usuario.perfil == "adm" &&
                        Selection(
                            {
                                name:"turmas",
                                text:"Turma: ",handleOnChange:handleInputChange,
                                options:(turmas),
                                value:formData.turma
                            })
                    }{
                        usuario.perfil == 'prof' &&
                    <div className={`${style.inputReadonlyWrapper}`}>
                    <label>Turma</label>
                    <input 
                        type="text" 
                        className={`${style.inputReadonly}`} 
                        value={formData.turmaNome || 'Sua Turma Padrão'} 
                        readOnly 
                    />
                    </div> 
                    }
                </div>
                <Button type='submit'>
                    Salvar
                </Button>
            </form>
        </div>
    </div>
    )
}

export const FormProfessor=({cadastramento, edit})=>{
    const {usuario} = useAuth()

    const {mostrarAviso} = useToast()
    const [email,setEmail] = useState("")
    const [senha,setSenha] = useState("")
    const [nome,setNome] = useState("")
    const [genero,setGenero] = useState("")
    const [dataNascimento, setDataNascimento] = useState(Date)
    const [turma,setTurma] = useState("")
    const [turmaNome, setTurmaNome] = useState("")
    const [turmas, setTurmas] = useState([])
    const [perfil,setPerfil] = useState("")    
    const [carregando, setCarregando] = useState(false)
    
    const buscar = (key,lista)=>{
        const tam = lista.length
        console.log(lista)
        for(let i = 0; i < tam; i++){
            if(key == lista[i].id){
                console.log("Aqui")
                return lista[i].nome
            }
        }
    }
    let attProf = {
        nome:"",
        genero:"",
        nascimento: Date(),
        turma: "",
        turmaNome: "",
        oferta: false,
        biblia: false,
        revista: false,
        email: "",
        senha: "",
        presencas: 0,
        pontos: 0,
    }
    const mudancaEstadoNome = (e)=>{
        setNome(e.target.value)
    }
    const mudancaEstadoTurma = (e)=>{
        setTurma(e.target.value)
        setTurmaNome(buscar(e.target.value,turmas))
    }
    const mudancaEstadoNascimento = (e)=>{
        setDataNascimento(e.target.value)
    }
    const mudancaEstadoGenero = (e)=>{
        setGenero(e.target.value)
    }
    const mudancaEstadoSenha = (e)=>{
        setSenha(e.target.value)
    }
    const mudancaEstadoEmail = (e)=>{
        setEmail(e.target.value)
    }
    const mudancaEstadoPerfil=(e)=>{
        setPerfil(e.target.value)
    }
    const perfis = [
        {nome:'prof'},
        {nome:'adm'}
    ]
    useEffect(()=>{
        if(edit){
            setTurma(edit.turma)
            setTurmaNome(edit.turmaNome)
            setNome(edit.nome)
            setDataNascimento(edit.nascimento)
            setGenero(edit.genero)
            setEmail(edit.email)
            setSenha(edit.senha)

        }
        getDocCollection("turmas",setTurmas,usuario.idEscola)
    },[])

    return(
    <div className={`${style.envelope_box}`}>
        <div className={`${style.cad_box}`}>
            <div className={`${style.cabecalhoForm}`} >
                <BiX size={30} onClick={cadastramento}/>
                <p className={`${style.cabecalhoFormp}`}
                >Preencha o formulário para realizar a matrícula</p>
            </div>
            <div>
                <div><label>Nome: <input 
                    type='text'
                    value={nome}
                    placeholder='Coloque o nome'
                    onChange={mudancaEstadoNome}
                    /></label></div>
                <div
                    style={{display:"flex",alignItems:"center",width:"100%", marginTop:'5px'}}
                >
                    <label
                        style={{fontSize: '15px'}}
                    >Masculino </label>
                    <input 
                            style={{width:'20px', margin:'4px'}}
                            value={"M"}
                            type='radio' 
                            name='genero'
                            onChange={mudancaEstadoGenero}/> 
                    <label
                        style={{fontSize: '15px'}}
                    >Feminino</label> 
                    <input 
                        value={"F"}
                        style={{width:'20px', margin:'4px'}}
                        type='radio' 
                        name='genero'
                        onChange={mudancaEstadoGenero}/>
                        
                </div>
                <div>
                    <label> Nascimento
                        <input
                            type='date'
                            value={dataNascimento}
                            onChange={mudancaEstadoNascimento}
                        />
                    </label>
                </div>

                <div>
                    {
                        Selection(
                            {
                                name:"turmas",
                                text:"turmas",handleOnChange:mudancaEstadoTurma,
                                options:turmas,
                                value:turma
                            })
                    }
                </div>
                {usuario?.perfil == "adm" && 
                <div>
                    {
                        Selection(
                            {
                                name:"perfil",
                                text:"Perfil",handleOnChange:mudancaEstadoPerfil,
                                options:perfis,
                                value:perfil
                            })
                    }
                </div>
                }
                <div>
                    <label>Email:<input 
                    type='email'
                    placeholder='Digite um E-mail válido'
                    value={email}
                    onChange={mudancaEstadoEmail}
                    /> </label>
                    </div>
                <div><label>Senha: <input 
                    type='password'
                    placeholder='Digite uma senha'
                    value={senha}
                    onChange={mudancaEstadoSenha}
                    /><span
                    style={{
                        
                        display:"flex",
                        justifyContent:"flex-end",
                        width:"100%",
                        fontSize:"12px",
                        color:"red",
                        marginTop:"0",
                    }}
                    >A senha deve conter mais de 6 caracteres</span>
                    </label>
                    </div>
            </div>
            {!edit && 
            <div
            className={`${style.button}`}
            
            onClick={ async ()=>{
            
                if(nome.length < 1){
                    mostrarAviso("Preencha o nome", "aviso")
                    return
                }
                if(dataNascimento.length != 10){
                    mostrarAviso("Informe uma data de nascimento", "aviso")
                    return
                }
                if(turma.length < 1){
                    mostrarAviso("Selecione o turma devidamente", "aviso")
                    return
                }
                if(perfil.length < 1){
                    mostrarAviso("Selecione o perfil de autorização correto", "aviso")
                    return
                }
                if(email.length < 1){
                    mostrarAviso("Coloque um email válido de acesso para o seu professor", "aviso")
                    return
                }
                if(senha.length < 6){
                    mostrarAviso("A senha deve ter mais que 6 caracteres","aviso")
                    return
                }

                const professor = {
                    nome:nome,
                    genero:genero,
                    nascimento: dataNascimento,
                    turma: turma,
                    turmaNome:turmaNome,
                    email:email,
                    senha:senha,
                    oferta: false,
                    biblia: false,
                    revista: false,
                    presencas: 0,
                    pontos: 0,
                    historico:{
                        biblias:[0,0,0,0],
                        revista:[0,0,0,0],
                        presenca:[0,0,0,0],
                        pontos:[0,0,0,0]
                    }
                }
                let idProf = await registrarProfessor({nome:nome,turma:turma,perfil:perfil},email,senha,usuario.idEscola,professor)
                cadastramento()
                let turmaAtualizada = {}
                turmas.forEach((item)=>{
                    if (item.id == turma){
                        item.professor.push(idProf.idProf)
                        turmaAtualizada = item
                    }
                })
                updateItem("turmas",turma,turmaAtualizada,usuario.idEscola)
                }}>
                    
                {
                    carregando ? (
                        <>
                        <span className={`${style.spinner}`}></span>
                            Salvando...
                        </>
                    ) : (<p>Salvar</p>)
                }     
                </div>
            }
            {edit && 
            <div
                className={`${style.button}`}
                
                onClick={()=>{
                    cadastramento()
                   
                    if(attProf.turma != turma){
                    let turmaAtualizada = {}
                    turmas.forEach((item)=>{
                    
                        if (item.id == turma){
                        item.professor.push(edit.id)
                        turmaAtualizada = item
                        }})
                        updateItem("turmas",turma,turmaAtualizada,usuario.idEscola)
                    }
                    
                    attProf.nome = nome
                    attProf.turma = turma
                    attProf.turmaNome = turmaNome
                    attProf.genero = genero
                    attProf.nascimento = dataNascimento
                    attProf.email = email
                    attProf.senha = senha
                    updateItem(
                        "professores",
                        edit.id,
                        attProf,
                        usuario.idEscola
                    )
                    
                }}
            ><p>Atualizar</p></div>
            }
            
        </div>
    </div>
    )
}

export default function FormTurma({cadastramento,edit}){
    const {usuario} = useAuth()

    const {mostrarAviso} = useToast()
    const [nome,setNome] = useState("")
    const [descricao,setDescricao] = useState("")
    const [grupoTurma,setGrupoTurma] = useState("")
    const [professor,setProfessor] = useState([])
    const [carregando, setCarregando] = useState(false)
    
    const mudancaEstadoDescricao = (e)=>{
        setDescricao(e.target.value)
    }
    const mudancaEstadoNome = (e)=>{
        setNome(e.target.value)
    }
    const mudancaEstadoGrupo = (e)=>{
        setGrupoTurma(e.target.value)
    }
    let attTurma = {
        nome: "",
        descricao: "",
        professor: [],
        grupo: ""
    }
    useEffect(()=>{
        if(edit){
            setNome(edit.nome)
            setDescricao(edit.descricao)
            setGrupoTurma(edit.grupo)
            setProfessor(edit.professor)
            attTurma.alunos = edit.alunos
            attTurma.professor = edit.professor  
            attTurma.grupo = edit.grupo
        }
    },[])
    const grupos = [
        {nome:'Berçário'},
        {nome:'Maternal'},
        {nome:'Primário'},
        {nome:'Juniores'},
        {nome:'Pré-adolescentes'},
        {nome:'Adolescentes'},
        {nome:'Juvenis'},
        {nome:'Jovens'},
        {nome:'Adultos'},
        {nome:'Discipulado'},
        {nome:'Classe Mista'}
    ]
    return(
    <div className={`${style.envelope_box}`}>
        <div className={`${style.cad_box}`}>
            <div className={`${style.cabecalhoForm}`} >
                <BiX size={30} onClick={cadastramento}/>
                <p className={`${style.cabecalhoFormp}`}
                >Insira as informações da turma</p>
            </div>
            <div>
                <div>
                    <label>Nome: 
                    <input 
                        placeholder='Insira o Nome da Turma'
                        type='text'
                        value={nome}
                        onChange={mudancaEstadoNome}
                    /></label>
                </div>
                <div>
                    <label>Descrição: 
                    <input 
                        placeholder='Descrição da turma'
                        type='text'
                        value={descricao}
                        onChange={mudancaEstadoDescricao}
                    /></label>
                </div>
                <div>
                    {
                        Selection(
                            {
                                name:"grupo",
                                text:"Grupo",handleOnChange:mudancaEstadoGrupo,
                                options:grupos,
                                value:grupoTurma
                            })
                    }
                    </div>
                <div style={{display:"flex",justifyContent:"center"}}>
                {!edit &&
                    <div
                        className={`${style.button}`}
                        onClick={()=>{
                            if(carregando)
                                return
                            if(nome.length < 1){
                                mostrarAviso("Preencha o nome","aviso")
                                return
                            }
                            if(!grupoTurma){
                                mostrarAviso("Selecione o grupo pertecente da turma", "aviso")
                                return
                            }
                            setCarregando(true)
                            const turma = {
                                nome:nome,
                                descricao:descricao,
                                grupo: grupoTurma,
                                professor: professor
                            }
                            cadastramento()
                            salvar({
                                localstore:"turmas",
                                item:turma,
                                idEscola:usuario.idEscola
                            })
                            setCarregando(false)
                        }}>

                        {
                            carregando ? (
                                <>
                                <span className={`${style.spinner}`}></span>
                                    Salvando...
                                </>
                            ) : (<p>Salvar</p>)
                        } 
                    </div>
                    }
                    {edit &&
                    <div       
                        className={`${style.button}`}                 
                        onClick={()=>{
                            if(nome.length < 1){
                                alert("Preencha o nome")
                                return
                            }
                            
                            attTurma.nome = nome
                            attTurma.grupo = grupoTurma
                            attTurma.descricao = descricao
                            attTurma.professor = professor
                            updateItem("turmas",edit.id,attTurma,usuario.idEscola)
                            cadastramento()
                        }}
                    ><p>Atualizar</p></div>}
                </div>
            </div>
        </div>
    </div>
    )
}

